class PopdownUpsellList extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-variant-id]').forEach((btn) => {
      btn.addEventListener('click', () => this.addToCart(btn));
    });
  }

  async addToCart(btn) {
    if (btn.classList.contains('loading') || btn.classList.contains('has-success')) {
      return;
    }

    btn.classList.add('loading');

    try {
      const body = new URLSearchParams({ id: btn.dataset.variantId, quantity: 1 }).toString();
      const addResponse = await fetch(`${window.theme.routes.cart}/add.js`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body,
      });

      if (!addResponse.ok) {
        throw new Error('Could not add product to cart');
      }

      const cartResponse = await fetch(`${window.theme.routes.cart}.js`);
      const cart = await cartResponse.json();

      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));

      btn.classList.remove('loading');
      btn.classList.add('has-success');
    } catch (error) {
      btn.classList.remove('loading');
      console.error(error);
    }
  }
}

if (!customElements.get('popdown-upsell-list')) {
  customElements.define('popdown-upsell-list', PopdownUpsellList);
}
